import { CompanyAPI } from '@api';

const getMulta = async (multaId) => CompanyAPI.getMulta(multaId)
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { getMulta };
